import React from "react";
import { t } from "ttag";

import type { ServerCmsTypesProductSummary as ProductSummary } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./index.module.scss";

const badgeLabel = (status: ProductSummary["status"]): string | null => {
    switch (status) {
        case "discontinued":
            return t`Discontinued`;
        case "coming_soon":
            return t`Coming Soon`;
        default:
            return null;
    }
};

interface Props {
    status: ProductSummary["status"];
    className?: string;
}

export const ProductStatusBadge = ({ status, className }: Props) => {
    const label = badgeLabel(status);
    if (!label) return null;
    const isDiscontinued = status === "discontinued";
    return (
        <span
            className={concatClassNames([
                isDiscontinued ? styles.badgeDiscontinued : styles.badge,
                className,
            ])}
        >
            {label}
        </span>
    );
};
